import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { axiosClient } from '../../../../library/Service/axiosClient';

const useManagementDashboard = () => {
    const { state, dispatch } = useContext(SmartContext);

    const getRecruiterDashboardData = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/dashboard-header-data`);
        setStateValue('reportData.dashboardCounts', response.data);
    };

    const getRecruiterWorkingIndustryData = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.recruiterWorkingIndustry };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/working-industry`, payload);
        setStateValue('reportData.recruiterWorkingIndustry', response.data);
    };

    const getRecruiterIndustryRolesData = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.recruiterIndustryRoles };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/industry-roles`, payload);
        setStateValue('reportData.recruiterIndustryRoles', response.data);
    };

    const getRecruiterProgramsAvgCTC = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.recruiterProgramsAvgCTC };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/programs-avg-ctc`, payload);
        setStateValue('reportData.recruiterProgramsAvgCTC', response.data);
    };

    const getRecruiterCompanies = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.recruiterCompanies };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/companies`, payload);
        setStateValue('reportData.recruiterCompanies', response.data);
    };

    const getRecruiterLocation = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.recruiterLocation, userTypeCode: "ALUMNI" };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/recruiters-location`, payload);
        setStateValue('reportData.recruiterLocation', response.data);
    };

    const getTypeOfRecruiters = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.typeOfRecruiters, userTypeCode: "ALUMNI" };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/type-of-recruiters`, payload);
        setStateValue('reportData.typeOfRecruiters', response.data);
    };

    const getPotentialRecruitersPieData = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.potentialRecruiters, userTypeCode: "ALUMNI" };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/potential-recruiter-pie`, payload);
        setStateValue('reportData.potentialRecruitersPie', response.data);
    };

    const getPotentialRecruitersBarData = async () => {
        let response: any;
        const payload = { ...state.data.searchCriteria?.potentialRecruiters, userTypeCode: "ALUMNI" };
        response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/recruiter-dashboard/potential-recruiter-bar`, payload);
        setStateValue('reportData.potentialRecruitersBar', response.data);
    };

    const setStateValue = (dataKey: string, value: string) =>
        dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey, value, errorMessages: [] } });


    return {
        setStateValue,
        getRecruiterDashboardData,
        getRecruiterWorkingIndustryData,
        getRecruiterIndustryRolesData,
        getRecruiterProgramsAvgCTC,
        getRecruiterCompanies,
        getRecruiterLocation,
        getTypeOfRecruiters,
        getPotentialRecruitersPieData,
        getPotentialRecruitersBarData
    };
};

export default useManagementDashboard;
